// Red v2 entrypoint — nieuwe ticketshop-viewlaag (epic AT-1100).
//
// Voorlopig hetzelfde fundament als red.js. Dat is geen luiheid maar een gevolg van
// het fallback-mechanisme uit AT-1101: staat een template nog niet in app/views/red2/,
// dan valt Rails terug op app/views/shopping_cart/, en die views hebben jQuery,
// Bootstrap, bootbox en red-legacy nodig (login, promo, modals, Safari Storage Access,
// iframe-messaging).
//
// Naarmate views migreren wordt deze lijst korter en de Stimulus-registratie langer.
// Exit-criterium (fase 6, AT-r): alles hierboven de Stimulus-blok eruit, samen met de
// Bootstrap-import in red2.scss.

import 'libraries/jquery-global'
import 'jquery-ujs'
import 'popper.js'
import 'bootstrap'
import toastr from 'toastr'
window.toastr = toastr
import 'vendor/bootbox-4.3.0'
import 'vendor/bootstrap-validator'
// resizer + iframeResizer.contentWindow worden als sync <script> in de layout geladen
import 'libraries/storage-access-api'
import 'libraries/locale'
import 'libraries/products-step'
import 'libraries/customer-information-step'
import 'libraries/idle'
import 'libraries/red-legacy'
import 'libraries/red2-scroll'
import 'libraries/red2-menu'
import 'libraries/event-video-embed'

// AT-1113: Turbo, maar alléén voor frames en streams.
//
// Turbo Drive staat uit. Aan zou het élke link en elk formulier in de shop overnemen,
// inclusief de views die nog niet gemigreerd zijn -- die leunen op rails-ujs, bootbox en
// red-legacy, en de data-remote-links die het iframe verlaten. Twee bibliotheken die
// dezelfde klik afhandelen levert geen winst maar een zoektocht op.
//
// Uit blijft alles zich gedragen zoals het deed; wat binnen een <turbo-frame> staat wordt
// wél door Turbo afgehandeld en mag een turbo-stream terugkrijgen. Zo kan de kortingscode
// zonder paginalading werken zonder dat de rest van de shop iets merkt.
// Named import: @hotwired/turbo-rails exporteert Turbo en cable, geen session op het
// hoogste niveau. Met een namespace-import is Turbo.session undefined en gooit de regel
// eronder -- dan valt de hele module om en wordt ook de Stimulus-registratie hieronder
// nooit uitgevoerd.
import { Turbo } from '@hotwired/turbo-rails'
Turbo.session.drive = false

import { Application } from "@hotwired/stimulus"
import PostcodeLookupController from '../controllers/postcode_lookup_controller'
import Red2AgendaController from '../controllers/red2_agenda_controller'
import Red2BusyController from '../controllers/red2_busy_controller'
import Red2BfcacheController from '../controllers/red2_bfcache_controller'
import Red2StepperController from '../controllers/red2_stepper_controller'
import Red2OrderGuardController from '../controllers/red2_order_guard_controller'
import Red2FieldCheckController from '../controllers/red2_field_check_controller'
import Red2InvoiceController from '../controllers/red2_invoice_controller'
import Red2TimerController from '../controllers/red2_timer_controller'
// AT-1058: de zaalplanstap is nog niet herbouwd en valt dus terug op
// shopping_cart/_seatplan_v2. Zonder deze registratie krijgt een red2-account met een
// v2-zaal de viewer wel te zien maar werkt er niets: geen klikken, geen zoomen.
import ShopSeatplanV2Controller from '../controllers/shop_seatplan_v2_controller'
// AT-1148: de mobiele uitklap van "Jouw stoelen" op het zaalplan. Die view is gedeeld met
// de oude Red, en daar stond deze registratie wél -- hier niet, waardoor de kop op mobiel
// nergens op reageerde voor precies de accounts die het nieuwe zaalplan draaien.
import SheetToggleController from '../controllers/sheet_toggle_controller'

const application = Application.start()
// Net als customer.js, management.js en signup2.js: de applicatie op window, zodat een
// feature-spec kan wachten tot een controller echt connected is. Zonder dat wachtpunt
// valt een klik of een gedispatcht event dat vóór de connect komt in het niets, en
// herhaalt Capybara daarna alleen de assertie -- niet de handeling. Zo viel
// red2_products_step_spec om in pipeline #2213.
window.Stimulus = application
application.register("postcode-lookup", PostcodeLookupController)
application.register("red2-agenda", Red2AgendaController)
application.register("red2-busy", Red2BusyController)
application.register("red2-bfcache", Red2BfcacheController)
application.register("red2-invoice", Red2InvoiceController)
application.register("red2-stepper", Red2StepperController)
application.register("red2-order-guard", Red2OrderGuardController)
application.register("red2-field-check", Red2FieldCheckController)
application.register("red2-timer", Red2TimerController)
application.register("shop-seatplan-v2", ShopSeatplanV2Controller)
application.register("sheet-toggle", SheetToggleController)
